

module.directive("donutChart", function($timeout, d3, defaultChartColors) {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            colors: '=',
            ticks: '=',
        },
        link: function(scope, element, attrs) {
            var pi = Math.PI,
                pie = d3.layout.pie().sort(null).startAngle(-pi).endAngle(pi),
                thickness = parseInt(attrs.thickness) || 16,
                colors = d3.scale.ordinal().range(scope.colors || defaultChartColors),
                chart = element[0],
                arc = d3.svg.arc(),
                triangle = d3.svg.symbol().type('triangle-up'),
                line = d3.svg.line(),
                svg = d3.select(chart).append('svg');

            svg.append('g').append('text');
            updateSvgData();

            if (attrs.colors) {
                scope.$watch('colors', function(newC, oldC) {
                    updateColors(newC, oldC ? 500 : 0);
                }, true);
            }

            scope.$on('resize', updateSvgData);
            scope.$watch('data', updateData, true);
            scope.$watch('ticks', updateTicks, true);
            attrs.$observe('text', updateText);

            function getSvgData() {
                return {
                    width: chart.offsetWidth,
                    outerRadius: chart.offsetWidth / 2 - 10,
                    innerRadius: chart.offsetWidth / 2- 10 - thickness,
                }
            }

            function updateSvgData() {
                var data = getSvgData()

                svg.datum(data)
                    .attr('width', attrgetter('width'))
                    .attr('height', attrgetter('width'));

                svg.select('g')
                    .attr('transform', function(d) {
                        return translate(d.width / 2)
                    });

                arc.outerRadius(data.outerRadius)
                   .innerRadius(data.innerRadius);

                triangle.size(thickness * 3); // mystery 3!
                line.x(0).y(function(d) { return d});

                updateText();
                updateData();
            }

            function updateText(text) {
                text = text || attrs.text;
                svg.select('text')
                    .text(text)
                    .style('font-size', '16px')
                    .style('font-size', function(d) {
                        var r = d.innerRadius - 15,
                            len = Math.max(30, this.getComputedTextLength());
                        return Math.min(2 * r, (2 * r - 8) / len * 16) + 'px';
                    }).attr('dy', '.3em');
            }

            function updateData(data) {
                data = data || scope.data || [];

                var arcs = svg.select('g').selectAll('path.arc')
                    .data(pie(data));

                arcs.enter().append("path")
                    .attr('class', 'arc')
                    .attr("d", arc)
                    .style('fill', byIndex(colors));

                arcs.transition().duration(500)
                    .attrTween('d', arcTween(d3, arc))
                    .style('fill', byIndex(colors));
            }

            function tickRotate(data) {
                var value = data.value || 0;
                return rotate(360 * value);
            }

            function tickOpacity(data) {
                return data.value || 0 > 0 ? 1 : 0;
            }

            function tickClass(data) {
                return 'tick ' + data.type  + ' ' + data.class;
            }

            function tickPath(data) {
                var path = d3.select(this),
                    offset = svg.datum().innerRadius;

                if (data.type === 'triangle') {
                    path.attr('d', triangle);
                    offset += thickness + this.getBBox().height / 2;
                } else if (data.type === 'line') {
                    path.attr('d', line([0, thickness * 1.33]));
                }
                path.attr('transform', translate(0, offset));
            }

            function updateTicks(data) {
                data = data || scope.ticks || [];

                var ticks = svg.select('g').selectAll('g.tick')
                    .data(data);

                ticks.enter().append('g')
                        .attr('class', tickClass)
                        .attr('transform', tickRotate)
                        .attr('opacity', tickOpacity)
                    .append('path').each(tickPath);

                ticks.transition().duration(500)
                    .attr('transform', tickRotate)
                    .attr('opacity', tickOpacity);

            }

            function updateColors(colorArray, duration) {
                colorArray = colorArray || defaultChartColors;
                colors.range(colorArray);
                duration = duration || 0;
                svg.select('g').selectAll('path.arc')
                    .transition().duration(duration)
                        .style('fill', byIndex(colors));
            }
        },
    }
});


function attrgetter(attr) {
    return function(d) {
        return d[attr];
    }
}

function translate(x, y) {
    y = angular.isUndefined(y) ? x : y;
    return 'translate(' + x + ',' + y + ')';
}

function rotate(deg) {
    return "rotate(" + deg + ")";
}


function arcTween(d3, arc) {
    return function(a) {
        this._current = this._current || a;
        var i = d3.interpolate(this._current, a);
        this._current = i(0);
        return function(t) {
            return arc(i(t))
        }
    }
}

function byIndex(fn) {
    return function(d, i) {
        return fn(i);
    }
}
